<template>
  <div class="accountSettings">
    <div class="grid">
      <section id="leftPane">


        <h1>ドライバー一覧</h1>

        <ul v-for="driver in drivers" v-bind:key="driver.id">
          <li class="driverButton"  :class="{disabled: (password.length === 0 || name.length === 0 || email.length === 0)}" @click="editDriver(driver)"><span class="driverName">{{driver.name}}</span><span  v-if="!$parent.isPhone" class="driverEmail">{{driver.email}}</span></li>
        </ul>


      </section>

      <section id="rightPane">

        <h1>ドライバーの追加</h1>
        <p class="warningMessage" v-if="isWarning">!未入力の項目があります!</p>


        <div id="customIdInputArea">
          <h3 class="inputTitle">ID（省略可）</h3>
          <input type="text" placeholder="" v-model="customId">
        </div>

        <div id="nameInputArea">
          <h3 class="inputTitle">名前</h3>
          <input :class="{warned: (isWarning && !name)}" type="text" placeholder="" v-model="name">
        </div>

        <div id="mailInputArea">
          <h3 class="inputTitle">メールアドレス</h3>
          <input :class="{warned: (isWarning && !email)}" type="text" placeholder="" v-model="email">
        </div>

        <div id="passwordInputArea">
          <h3 class="inputTitle">パスワード</h3>
          <input :class="{warned: (isWarning && !password)}" type="text" placeholder="" v-model="password">
        </div>

        <div id="phoneInputArea">
          <h3 class="inputTitle">電話番号（省略可）</h3>
          <input type="text" placeholder="" v-model="phone">
        </div>

        <div>
          <h2 class="inputTitle" >車種（省略可）</h2>
          <select class="vehicleSelect" v-model="vehicleType" @change="onVehicleTypeChange($event)">
            <option value="" disabled selected>車種を選択してください</option>
            <option v-for="type in vehicleTypes" :value="type">
              {{ type }}
            </option>
          </select>
          <!--<p v-if="selected_driver_name">{{selected_driver_name}}</p>-->
        </div>

        <div>
          <button class="button" :class="{disabled: isButtonDisabled}" @click="addDriver">追加</button>
        </div>


        <div class="loadingBackground" v-if="isLoading">
          <div class="loadingDialog">
            <half-circle-spinner
              :animation-duration="1000"
              :size="60"
              :color="'#ffffff'"
            />
          </div>
        </div>



      </section>
    </div>


  </div>

</template>


<script >
  import {fbFunctions, auth, db, fb} from '../firebase'
  import {HalfCircleSpinner} from 'epic-spinners'

  export default {
    name: 'DriverSettings',

    components: {
      HalfCircleSpinner
    },

    data () {
      return {

        uid: '',
        customId: null,
        name: '',
        email: '',
        password: '',
        phone: null,
        vehicleType: null,

        /* ドライバーリスト(Firestoreから取得) */
        drivers: [
          {
            id: 'foo',
            name:'bar'
          }

        ],

        /* 車種のリスト */
        vehicleTypes: ['bike', 'car'],

        isLoading: false,

        /* 入力にエラーがあるかどうかのフラグ */
        isWarning: false

      }
    },

    computed: {
      companyId() {
        let coId = this.$store.getters.companyId
        if(coId){
          return coId
        }

        //localStorageに存在したらそれをVuexのstoreに書き込んでリターンする。
        if (localStorage.companyId) {
          this.$store.commit('setCompanyId', localStorage.companyId)
          return localStorage.companyId
        }
      },

      isButtonDisabled() {
        if(this.name && this.email && this.password){
          return false
        }
        return true
      }
    },

    methods: {

      getDrivers () {
        this.$bind('drivers', db.collection('companies').doc(this.companyId).collection('drivers')).then(drivers => {
          //this.$unbind('drivers')
        })
      },

      async addDriver() {

        if(this.isButtonDisabled){
          console.log("button is disabled")
          this.isWarning = true
          return
        }

        this.isWarning = false

        //TODO: パスワードcheckをいれる


        try {

          this.isLoading = true

          var createDriver = fbFunctions.httpsCallable('createDriver');
          let result = await createDriver({
            email: this.email,
            //phoneNumber: '080-0000-0000',
            password: this.password,
            name: this.name,
          })

          this.uid = result.data.uid
          let newUserEmail = result.data.email
          //let newUserPhoneNumber = result.data.phoneNumber
          let newUserName = result.data.name
          let newUserPassword = result.data.password
          console.log("New driver created", newUserEmail, newUserName, newUserPassword)
        }catch(error){
          // Getting the Error details.
          var code = error.code;
          var message = error.message;
          //var details = error.details;

          console.log('Error creating driver:', code, message);

          if(code === 'already-exists'){
            //すでに同じemailのユーザーがいる。
          }else if (code === 'invalid-argument'){
            //パラメターがおかしい
          }
          console.log('Error creating the driver:', error);
          this.isLoading = false
          return
        }

        if(this.uid) {
          try{
            if(this.uid){
              await db.collection('accounts').add({companyId:this.companyId, userId:this.uid})
            }
          }catch (error) {
            console.log('Error updating accounts collection', error);
            this.isLoading = false
            return
          }

          try{
            var data = {name:this.name, email:this.email}
            if(this.phone) { data.phone = this.phone }
            if(this.customId) { data.customId = this.customId }
            if(this.vehicleType) { data.vehicleType = this.vehicleType }
              await db.collection('companies').doc(this.companyId).collection('drivers').doc(this.uid).set(data)
          }catch (error) {
            console.log('Error updating drivers collection:', error);
            this.isLoading = false
            return
          }
        }else{
          console.log("new driver's uuid is null.")
        }

        this.isLoading = false

      },

      editDriver(driver) {
        //this.$router.push({ name: 'EditDriver', params: {driverProps: driver }})
        this.$router.push({ name: 'EditDriver', query: { id: driver.id, customId: driver.customId, name: driver.name, email: driver.email, phone:driver.phone, vehicleType:driver.vehicleType }})
      },

      onVehicleTypeChange(event) {
        let vehicleType = event.target.value
        if(vehicleType){
          this.vehicleType = vehicleType
        }
      },
    },


    mounted() {
      if(!this.companyId){
        this.$router.push('/signin')
      }else{
        this.getDrivers()
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /* グリッドレイアウト */
  .grid {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr minmax(180px, 1fr);
    height:100vh;
  }



  #leftPane {
    text-align: left;
    margin-left: 2em;
  }

  #leftPane h1{
    color: #5C5C5C;
    font-size: 33px;
    font-weight: normal;
    margin-top: 40px;
  }

  #rightPane {
    text-align: left;
    margin-left: 2em;
  }

  #rightPane h1{
    color: #5C5C5C;
    font-size: 33px;
    font-weight: normal;
    margin-top: 40px;
  }

  h2 {
    color: #5C5C5C;
    font-size: 25px;
    font-weight: normal;
    margin-top: 40px;
  }

  h3 {
    margin-top: 0;
    margin-bottom: 0;
  }

  input {
    width: 300px;
    height: 35px;
    margin-top: 0;
  }


  #mailInputArea input {
    width: 400px;
  }

  .inputTitle {
    color: #5C5C5C;
    font-size: 20px;
    font-weight: lighter;
    margin-top: 2px;

  }

  ul {
    list-style-type: none;
  }

  #letPane li {
    list-style: none;
    padding-left: 0;
    margin-top: 4px;
    margin-bottom: 4px;
  }

  .driverButton {
    background-color: #FFFFFF;
    border-style: solid;
    border-color: #D2D2D2;
    padding: 13px 22px 12px 22px;
    outline: none;
    margin-top: 20px;
    width:430px
  }

  .driverName{
    margin-left: 20px;
    color: #5C5C5C;
    font-size: 18px;
    font-weight: normal;
  }

  .driverEmail{
    margin-left: 40px;
    color: #5C5C5C;
    font-size: 18px;
    font-weight: normal;
  }

  button.disabled {
    background-color: #D2D2D2;
  }


  button.disabled:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
  }

  /* 未入力の項目の警告用スタイル */
  .warned {
    background-color: #F3C99F;
  }

  .warningMessage {
    color: #FF6B49;
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 0;
  }



  input {
    width: 340px;
    height: 28px;
    padding: 10px;
    border-style: solid;
    border-width: 2px;
    border-color: #D2D2D2;
    box-shadow: 0 0 0 #D2D2D2;
  }

  input:focus {
    outline: none !important;
    border:2px solid #D2FF00;
    box-shadow: 0 0 0 #D2FF00;
  }


  @media(max-width: 768px){
    .grid {
      display: block;
    }

    #leftPane {
      margin: 0 auto 0 auto;
    }

    #leftPane h1{
      text-align: left;
      color: #5C5C5C;
      font-size: 21px;
      font-weight: bold;
      margin-top: 39px;
      margin-left: 25px;
    }

    #rightPane {
      text-align: center;
      margin: 0 auto 0 auto;
    }

    #rightPane h1{
      text-align: left;
      color: #5C5C5C;
      font-size: 21px;
      font-weight: bold;
      margin-top: 39px;
      margin-left: 25px;
    }


    #leftPane ul {
      text-align: left;
      padding: 5px 0 5px 0;
    }

    #leftPane li {
      width: 90%;
      margin: 0 auto 0 auto;
      list-style: none;
      border-width: 1px;
    }

    .driverButton {
      background-color: #FFFFFF;
      border-style: solid;
      border-color: #D2D2D2;
      padding: 13px 2px 12px 2px;
      outline: none;
      margin-top: 20px;
      text-align: left;
    }

    .driverName{
      margin-left: 1px;
      color: #5C5C5C;
      font-size: 18px;
      font-weight: normal;
      padding-left: 13px;
    }


    /* 未入力の項目の警告用スタイル */
    .warned {
      background-color: #F3C99F;
    }

    .warningMessage {
      color: #FF6B49;
      font-size: 15px;
      margin-top: 0;
      margin-bottom: 0;
    }

    .inputTitle {
      text-align: left;
      color: #5C5C5C;
      font-size: 15px;
      font-weight: lighter;
      margin-top: 2px;
      margin-left: 25px;
      margin-bottom: 0;
    }

    input {
      width: 86%;
      margin: 0 auto 0 auto;
      height: 28px;
      padding: 10px;
      border-style: solid;
      border-width: 1px;
      border-color: #D2D2D2;
      box-shadow: 0 0 0 #D2D2D2;
    }

    input:focus {
      outline: none !important;
      border:2px solid #D2FF00;
      box-shadow: 0 0 0 #D2FF00;
    }

    #mailInputArea input {
      width: 86%;
    }

    .button {
      text-align: center;
      margin-top: 20px;
      margin-bottom: 25px;
      padding: 7px 10px 7px 10px;
      font-weight: bold;
      font-size: 15px;
    }

    /* 車種選択 */
    .driverSelect {
      margin: 0 auto 0 auto;
      padding: 0 0 0 0;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/DriverSettings.vue